module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAAAXNSR0IArs4c6QAAANxJREFUKFONjzFKA2EQhb99BAkGRIKVBAsJm95CLEJqsfAM1iEHyEG2thKxtBZrC08QliAewGKxisG8lR/8k2XZhUw1zJtv3puEbQ360BtLnAJHUHZB+pfX4JXNFziH5XsSOSmdgU52h9o7e/NcBeeg7n6gX7cgDG+lzsWeYFYBB33pMMSNfzXesL2A/KkChr3RtZRctbuWv/ZPBp9FDeQARlMpOW6CbV5g8Ra0Ogicn0mdu3pk2x+QPwBuAcM4vZR0E13tsoDNPSy/46zBMUrpGDQBF7B+DH9V4/8Bepo//rkkJAkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cartojourney/img27.png
// module id = 6Hdh
// module chunks = 1